export default __webpack_public_path__ + "static/4th-of-july-summer-steals-banner-desktop-435827f2ebf403bd0613592617c27e72.webp";